import React from 'react';
import {Button, Media, Row} from 'reactstrap';
import assets from '../../../../../util/assets';

const EmptyComponent = (props) => {

    let message = {
        title: "No content found",
        description: "Sorry, there is no content found at the moment. Try using search to find what you are looking for."
    }

    if (props.searchValue !== "") {
        message = {
            title: "No results found",
            description: "Try adjusting your search to find what you are looking for"
        }
    }
    return (
        <Row className="display-flex-vertical-center my-library-empty-state-container flex-direction-column">
            <Media object src={assets.clipstore.EmptyState} alt="Generic placeholder image"/>
            <div className="my-library-empty-state-title">{message.title}</div>
            <div className="my-library-empty-state-subtitle">{message.description}</div>
            {
                props.searchValue === "" &&
                <Button color="primary" className="my-library-empty-state-action" onClick={props.uploadContent}>UPLOAD CONTENT</Button>
            }
        </Row>
    );
}

export default EmptyComponent;